export enum ProvisioningStatus {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  FINISHED = 'FINISHED',
  ERROR = 'ERROR',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  HIBERNATED = 'HIBERNATED',
}
